import { Card, Form, Input, Button, Row, Col, Select } from "antd";
import styled from "styled-components";

const { Item, useForm } = Form;

interface FiltersProps {
  data?: any[];
  handleFilter: (args: any) => void;
}

function Filters({ data, handleFilter }: FiltersProps) {

  const [form] = useForm();

  const statusOptions = [
    { value: null, label: "Todos" },
    { value: true, label: "Ativos" },
    { value: false, label: "Inativos" },
  ];

  return (
    <Card style={{ margin: 16, borderRadius: 8 }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFilter}
      >
        <Row gutter={[8, 8]}>
          <Col span={4}>
            <Item label="DESCRIÇÃO" name="descricao" style={{ margin: 0 }}>
              <Input
                size="large"
                placeholder="Descrição"
                style={{ borderRadius: 8 }}
              />
            </Item>
          </Col>

          <Col span={4}>
            <Item label="STATUS" name="ativo" style={{ margin: 0 }}>
              <StyledSelect
                allowClear
                size="large"
                options={statusOptions}
                placeholder="Status"
              />
            </Item>
          </Col>

          <Col span={2} style={{ display: "flex", alignItems: "flex-end" }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ width: "100%", borderRadius: 8, backgroundColor: "#12619C" }}
            >Filtrar</Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 8px !important;
  }
`;

export default Filters;